import React, { useEffect, useState } from 'react';
import { getCachedMediaUrl } from '../../../../lib/utils/utils';
import RedDelete from "../../../../Assets/redDelete.svg";
import { deleteMedia } from '../../../../lib/utils/apiCalls';
import { useDispatch } from 'react-redux';
import { fetchMedia } from '../../../../Features/storefrontSlice';

function ImageBox({ media }) {
    const dispatch = useDispatch();

    const [deleteButtonVisible, setDeleteButtonVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    useEffect(() => {
        if(hoverOnBox) {
            setDeleteButtonVisible(true);
        } else {
            setDeleteButtonVisible(false);
        }
    }, [hoverOnBox]);

    async function handleDeleteButtton() {
        try {
            const response = await deleteMedia(media.id, { id: media.id });
            if(response.status === 200) {
                dispatch(fetchMedia());
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className="w-full aspect-square flex items-center justify-center relative" 
        >
            {
                deleteButtonVisible && 
                <div className="absolute top-0 right-0 p-2">
                    <button onClick={handleDeleteButtton} className="size-8 flex items-center justify-center rounded-full bg-[#FFFFFF] outline-none shadow-[0px_0px_12px_0px_#0000003D]">
                        <img src={RedDelete} alt="" />
                    </button>
                </div>
            }

            <img className='max-h-full max-w-full' src={getCachedMediaUrl(media.pic)} alt={media.keyData} />
        </div>
    );
}

export default ImageBox;
